import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {Col, Input, Row, Tooltip} from "reactstrap";

function AnswerContainer(props) {
	const {component, answer, onClick, classes, isNotActive, checked, answersImage} = props

	return (
		<Col
			key={answer ? answer.id : ""}
			sm={12}
			className={classnames({
				'px-1': classes && classes.includes("p-0") ? false : true
			}) + " " + classes}
		>
			<div
			className={classnames({
				'cafetery-wrap d-flex flex-column w-100 h-100': true,
				'justify-content-center flex-column': answersImage ? answersImage : false,
				'active': !!checked,
				"not-active": isNotActive,
			})}
			data-position={answer ? answer.position : ""}
			id={answer ? `tooltip-${answer.id}` : ""}
			onClick={onClick}
		>
				{component}
			</div>
		</Col>
	);
}

AnswerContainer.propTypes = {
	classes: PropTypes.string,
	onClick: PropTypes.func,
	answer: PropTypes.any,
	component: PropTypes.any,
	isNotActive: PropTypes.any,
	answersImage: PropTypes.any,
	checked: PropTypes.bool
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(AnswerContainer);